<template>
  <div>
    <v-layout justify-center>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="grey lighten-5">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Adjust Geolocation</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-layout class="align-center fill-height">
                <v-btn class="mr-0" icon dark @click="dialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-layout>
            </v-toolbar-items>
          </v-toolbar>
          <v-container class="fill-height pa-6">
            <div class="adjust-geolocation-wrapp" style="width: 100%;">
              <div>
                  <div class="no-routes-wrapper mb-1">
                      <div>
                          <div class="subheading">Please drag location pin to desired position and press Save</div>
                      </div>
                      <!-- <div>{{ markerPosition }}</div> -->
                  </div>
                  <v-layout class="wrap mb-2 justify-end">
                    <v-btn
                      color="primary"
                      class="mr-0 ml-2 my-1"
                      :disabled="disableButtons || saveGeolocationLoading"
                      @click="resetPosition"
                    >
                      Reset Position
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="mr-0 ml-2 my-1"
                      :disabled="disableButtons || saveGeolocationLoading"
                      :loading="saveGeolocationLoading"
                      @click="saveGeolocation"
                    >
                      Save <v-icon right>save</v-icon>
                    </v-btn>
                  </v-layout>
                  <v-alert class="pa-2 mb-4" :value="!serverValidation" outlined color="error" icon="priority_high"
                           transition="scale-transition">
                      <span class="caption">{{ serverValidationMessage }}</span>
                  </v-alert>
                  <div class="google-map elevation-3" :id="mapName"></div>
              </div>

            </div>
          </v-container>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import { mapState, mapActions } from "vuex"
import moment from "moment"

export default {
  name: 'AdjustGeolocation',
  data: () => ({
    dialog: false,
    no_data: [null, '', undefined, 'null'],
    item: null,
    mapName: "edit-geolocation-map",
    marker: null,
    saveGeolocationLoading: false,
    serverValidation: true,
    serverValidationMessage: 'Oops something went wrong...',
    server_errors: {},
    unsubscribe: null
  }),
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'EditGeoLocation') {
          this.openModal(action.payload.data)
      }
    })
  },
  beforeDestroy () {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['vEmit']),
    defineMap() {
        this.bounds = new google.maps.LatLngBounds();
        const element = document.getElementById(this.mapName)
        const options = {
            zoom: 14
        }
        this.map = new google.maps.Map(element, options);
    },
    setUpMap(){
      let location = _.cloneDeep(this.item)

      const marker = new google.maps.Marker({
          position: {lat: location['lat'], lng: location['lng']},
          title: `Adjust pin to desired location`,
          draggable:true,
          animation: google.maps.Animation.DROP,
          map: this.map,
          optimized: false
      });
      marker.setVisible(true);

      this.marker = marker
      this.map.setCenter({lat: location['lat'], lng: location['lng']});
      this.map.setZoom(17);
    },
    resetPosition() {
      this.marker.setPosition({lat: this.item['lat'], lng: this.item['lng']})
    },
    openModal(item) {
      this.item = item
      this.dialog = true
      this.$nextTick(() => {        
        this.defineMap()
        this.setUpMap()
      })
    },
    saveGeolocation () {
      this.saveGeolocationLoading = true
      this.resetServerValidation()
      let body = {
        old_value: {
          lat: this.item.lat,
          lng: this.item.lng
        },
        new_value: {
          lat: this.marker.position.lat(),
          lng: this.marker.position.lng()
        },
        lat: this.marker.position.lat(),
        lng: this.marker.position.lng()
      }
      if(Boolean(this.item.commercial)) {
        body.commercial_client_id = this.item.commercial_client_id
        body.commercial_location_id = this.item.commercial_location_id
      } else {
        body.client_id = this.item.client_id
      }
      
      ApiService.put('/scheduler/update_client_geolocation', body)
        .then(response => {
          this.$emit('done', this.item.id)
          this.vEmit({ 
            name: "notification", 
            data: {
              status: 'success', 
              text: 'Geolocation has been successfully updated.'
            }
          });
          this.saveGeolocationLoading = false
          this.dialog = false
        })
        .catch(({ response }) => {
          this.saveGeolocationLoading = false
          this.serverValidation = false
          if(response.data.error){
              this.serverValidationMessage = this.titleCase(response.data.error)
          }
          if(response.data.message){
              this.serverValidationMessage = response.data.message
          }
          if(response.data.errors) {
              this.server_errors = response.data.errors
          }
        })
    },
    titleCase(str){
        return _.startCase(str.replace(/_/g, ' '));
    },
    resetServerValidation() {
        this.serverValidation = true
        this.serverValidationMessage = 'Oops something went wrong...'
        this.server_errors = {}
    }
  },
  computed: {
    disableButtons () {
      return this.item === null || this.marker === null || this.marker.position.lat() == this.item.lat || this.marker.position.lng() == this.item.lng
    },
    ...mapState({
        user_id: state => state.auth.user.user_id,
    })
  }
}
</script>

<style scoped>
  .google-map {
      width: 100%;
      height: 600px;
      height: 75vh;
      margin: 0 auto;
      background: #e5e3df;
  }
</style>